import { render } from "./AwardStore.vue?vue&type=template&id=e594375a&scoped=true&ts=true"
import script from "./AwardStore.vue?vue&type=script&lang=ts"
export * from "./AwardStore.vue?vue&type=script&lang=ts"

import "./AwardStore.vue?vue&type=style&index=0&id=e594375a&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e594375a"]])

export default __exports__